import * as GameCommands from "../../core/src/commands/GameCommands";
import { DefaultLayers } from "../../core/src/utils/Layers";
import ViewManager from "../../core/src/utils/ViewManager";
import { UIButtons } from "../../core/src/ui/UIButtons";
import SwitchButton from "../../core/src/views/components/SwitchButton";
import UIController from "../../core/src/ui/UIController";
import SoundController from "../../core/src/utils/SoundController";
import CommManager from "../../core/src/controllers/CommManager";
import RequestRegister from "../../core/src/server/requests/RequestRegister";
import stateMachine from "../../core/src/states/StateMachine";
import GameModel from "../../core/src/model/GameModel";
import BetModel from "../../core/src/model/BetModel";
import JackpotsModel from "../model/JackpotsModel";
import VendorWrapper from "../controllers/VendorWrapper";
import IJackpotData from "../server/data/IJackpotData";
import SoundVars from "../../core/src/const/SoundVars";
import AutoplayModel from "../../core/src/model/AutoplayModel";
import { DefaultStates } from "../../core/src/states/DefaultStates";
import App from "../../core/src/App";
import VendorModel from "../model/VendorModel";
import ReelGroup from "../../core/src/views/ReelGroup";
import { UIModes, UIStates } from "../../core/src/ui/UIStates";
import { UIUpdateEvent } from "../../core/src/ui/UIUpdateEvents";
import CommandManager from "../../core/src/commands/CommandManager";
import { Commands } from "../../core/src/commands/CommandEnum";
import HTMLPopupsManager from "../../core/src/utils/HTMLPopupsManager";
import { VendorCommandsEnum } from "./VendorCommandsEnum";
import * as FEIM from "@rlx/feim";
import SpinModel from "../../core/src/model/SpinModel";
import { ConfigurationTypes } from "../../core/src/const/ConfigurationTypes";
import ConfigManager from "../../core/src/managers/ConfigManager";
import Configs from "../vendorConfigs/Configs";
import UIUtils from "../../core/src/utils/UIUtils";
import Locale from "../../core/src/utils/Locale";
import { Tween } from "../../core/src/Tween";
import Button from "../../core/src/views/components/Button";


export function SetBetCommand(betData:{ coinIndex: number, multiplier: number, value: number }) {
    BetModel.setStake(betData.multiplier, betData.coinIndex);
    GameCommands.UpdateBetCommand();
    if (BetModel.totalBet > 0) {
        CommandManager.execute(VendorCommandsEnum.BET_UPDATE, BetModel.totalBet);
    }
}

export function ToggleBetPopupCommand(visible) {
    const isBuyFeatureEnabled = ConfigManager.hasConfig(ConfigurationTypes.GAME) && !Configs.game.clientConfig.disableBuyFeature;
    const isTurboEnable = ConfigManager.hasConfig(ConfigurationTypes.GAME) && Configs.game.clientConfig.quickStop;
    const disabledBtnNames: string[] = [UIButtons.AutoPlay, UIButtons.Spin, UIButtons.Bet, UIButtons.Settings];

    const buttons = ViewManager.getLayer(DefaultLayers.BetBar)
    .setScene().buttons;

    if ( isTurboEnable && buttons.has("turbo")) {
        disabledBtnNames.push(UIButtons.Turbo);
    }

    if (isBuyFeatureEnabled) {
        let buyBtnsGroup = ViewManager.getLayer(DefaultLayers.BetBar)
            .setScene().groups.get("btn_buy_feature");
        // check for all buy buttons in their group and add them to the disabledBtnNames
        buyBtnsGroup.children.forEach((child) => {
            if (child instanceof Button) {
                buttons.forEach((btn, name) => {
                    if (child == btn) {
                        disabledBtnNames.push(name);
                    }
                });
            }
        });
    }

    buttons.forEach((btn, name) => {
        if(disabledBtnNames.indexOf(name) != -1) {
            btn.setEnabled(visible != true ? false : true);
        }
    });
    GameCommands.ToggleBetPopupCommand();
}

export function ToggleAutoplayPopupCommand(visible) {
    const isBuyFeatureEnabled = ConfigManager.hasConfig(ConfigurationTypes.GAME) && !Configs.game.clientConfig.disableBuyFeature;
    const isTurboEnable = ConfigManager.hasConfig(ConfigurationTypes.GAME) && Configs.game.clientConfig.quickStop;
    const disabledBtnNames: string[] = [UIButtons.AutoPlay, UIButtons.Spin, UIButtons.Bet, UIButtons.Settings];

    const buttons = ViewManager.getLayer(DefaultLayers.BetBar)
        .setScene().buttons;

    if ( isTurboEnable && buttons.has("turbo")) {
        disabledBtnNames.push(UIButtons.Turbo);
    }

    if (isBuyFeatureEnabled) {
        let buyBtnsGroup = ViewManager.getLayer(DefaultLayers.BetBar)
            .setScene().groups.get("btn_buy_feature");
        // check for all buy buttons in their group and add them to the disabledBtnNames
        buyBtnsGroup.children.forEach((child) => {
            if (child instanceof Button) {
                buttons.forEach((btn, name) => {
                    if (child == btn) {
                        disabledBtnNames.push(name);
                    }
                });
            }
        });
    }

    buttons.forEach((btn, name) => {
        if(disabledBtnNames.indexOf(name) != -1) {
            btn.setEnabled(visible != true ? false : true);
        }
    });
    GameCommands.ToggleAutoplayPopupCommand();
}

export function ToggleSwipeToSpinCommand() {
    VendorModel.allowSwipeSpin = !VendorModel.allowSwipeSpin;

    const scene = ViewManager.getLayer(
        DefaultLayers.Reels
    ).getCurrentScene();

    const reelGroup = scene.getSubView("ReelGroup") as ReelGroup;
    VendorModel.allowSwipeSpin ? reelGroup.enableSwipeSpin() : reelGroup.disableSwipeSpin();
    SoundController.playSound(SoundVars.BUTTON_CLICK);
}

export function ToggleSkipIntroCommand() {
    VendorModel.allowSkipIntro = !VendorModel.allowSkipIntro;
}

export function ToggleTuboSpinCommand() {
    GameCommands.ToggleTuboSpinCommand();
    let btn = ViewManager.getLayer(DefaultLayers.BetBar)
        .getCurrentScene()
        .buttons.get(UIButtons.Turbo) as SwitchButton;
    btn?.toggle();
    CommandManager.execute(VendorCommandsEnum.FAST_PLAY_ACTIVATED, GameModel.turboSpin);
    SoundController.playSound(SoundVars.BUTTON_CLICK);
}

export function ToggleSoundPopupCommand() {
    UIController.toggleComponent("soundPopup");
    let btn1 = ViewManager.getLayer(DefaultLayers.BetBar)
        .getCurrentScene()
        .buttons.get(UIButtons.Sound) as SwitchButton;
    btn1.toggle();
    let btn2 = ViewManager.getLayer(DefaultLayers.BetBar)
        .getCurrentScene()
        .buttons.get(UIButtons.SoundMuted) as SwitchButton;
    btn2.toggle();
}
export function ToggleSoundButtonCommand(param?: any) {
    if (GameModel.sessionID) {
        let btn1 = ViewManager.getLayer(DefaultLayers.BetBar)
            .setScene()
            .buttons.get(UIButtons.Sound) as SwitchButton;
        btn1.visible = SoundController.isSoundEnabled;
        let btn2 = ViewManager.getLayer(DefaultLayers.BetBar)
            .setScene()
            .buttons.get(UIButtons.SoundMuted) as SwitchButton;
        btn2.visible = !SoundController.isSoundEnabled;

        if (param == "uiSoundBtn") {
            GameCommands.SaveSettingsCommand();
        }
    }
}

export const ToggleMasterSoundBtn = (enabled?: boolean) => {
    SoundController.toggleMasterSound(enabled);
    let btn = ViewManager.getLayer(DefaultLayers.BetBar)
        .getCurrentScene()
        .buttons.get(UIButtons.Sound) as SwitchButton;
    btn.switch(!SoundController.isSoundEnabled);
    GameCommands.SaveSettingsCommand();
};

export const ToggleSoundFXCommand = (enabled?: boolean) => {
    SoundController.toggleEffects(enabled);
    let btn = ViewManager.getLayer(DefaultLayers.BetBar)
        .getCurrentScene()
        .buttons.get(UIButtons.Sound) as SwitchButton;
    btn.switch(!SoundController.isSoundEnabled);
    ToggleSoundButtonCommand();
    GameCommands.SaveSettingsCommand();
};

export const ToggleMusicCommand = (enabled?: boolean) => {
    SoundController.toggleMusic(enabled);
    let btn = ViewManager.getLayer(DefaultLayers.BetBar)
        .getCurrentScene()
        .buttons.get(UIButtons.Sound) as SwitchButton;
    btn.switch(!SoundController.isSoundEnabled);
    ToggleSoundButtonCommand();
    GameCommands.SaveSettingsCommand();
};

export function UpdateJackpotsCommand() {
    if (GameModel.gameConfig.hasJackpotsFeature && JackpotsModel.jackpotsAvailable) {
        CommManager.send(
            RequestRegister.get("jackpotsUpdate"),
            async function (data: any) {
                VendorWrapper.setJackpotValues(data.data as IJackpotData[]);
            },
            this
        );
    }
}
export function ToggleJackpotBtnCommand(state: boolean) {
    let btn = ViewManager.getLayer(DefaultLayers.BetBar)
        .getCurrentScene()
        .buttons.get("jackpot") as SwitchButton;
    btn.switch(state);
}
export function SkipFreeSpins() {
    CommManager.send(RequestRegister.get("skipFreeGames"), (data) => {
        // ShowHistoryPage(data);
    }, this);
}
export function CancelFreeSpins(updateBalanceImmediately = true){
    CommManager.send(RequestRegister.get("cancelFreeGames"), (data) => {
        // ShowHistoryPage(data);
        if (updateBalanceImmediately) {
            if (data?.stats?.b != undefined) {
                GameModel.shouldUpdateBalance = false;
                BetModel.balance = data.stats.b;
                UIController.updateFields(UIUpdateEvent.Balance);
            }
        }

    }, this);
}
export function ShowInsufficientFoundsDialog(callback) {
    UIController.toggleComponent("insufficientFundsPopup", callback);
}

export function makeBalanceRequest() {
    CommManager.send(
        RequestRegister.get("getBalance"),
        (data) => {
            GameModel.shouldUpdateBalance = false;
            BetModel.balance = data.b;
            VendorModel.update(data);
        },
        this
    );
}

export function StopAutoplayCommand() {
    if(!(SpinModel.inFreegames() && VendorModel.freeGames.autoplay)) {
        AutoplayModel.setAutoSpin(-1);
        UIController.setState(UIStates.AUTO_STOP);

        CommandManager.execute(VendorCommandsEnum.AUTOPLAY_FINISHED);
    }

}

export function DecrimentAutoplay() {
    AutoplayModel.decrementAutoSpinNum();
    if (AutoplayModel.getAutoSpinNum() <= 0) {
        CommandManager.execute(VendorCommandsEnum.AUTOPLAY_FINISHED);
    }
    UIController.updateFields(UIUpdateEvent.Autoplay);
}

export function GoHome() {

    if (GameModel.homeUrl) {
        if (GameModel.homeUrl === "close") {
            window.close();
        } else {
            FEIM.send.exitGame();
        }
    } else {
        window.history.back();
    }
}

export function OpenRCHistory() {
    CommandManager.execute(VendorCommandsEnum.SHOW_HISTORY)
}

export function ToggleSettingsCommand() {
    UIController.toggleComponent("settings", "paytable");
    if (GameModel.homeUrl) {
    } else {
        const scene = ViewManager?.getLayer(DefaultLayers.MenuUI)?.getCurrentScene();
        const homeBtn  = scene?.buttons?.get(UIButtons.Home);
        homeBtn?.setVisible(false);
    };
}

export function ToggleGameInfoCommand() {
    UIController.toggleComponent("settings", "gameinfo");
}

export function RequestHistory() {
    CommandManager.execute(Commands.TOGGLE_SETTINGS);
    CommandManager.execute(VendorCommandsEnum.GAME_PAUSED, true);
    ViewManager.getLayer(DefaultLayers.SplashOverlay).setScene("open");
    CommManager.send(RequestRegister.get("historyRequest"), (data) => {
        ShowHistoryPage(data);
    }, this, async () => {
        await UIUtils.showErrorBox(Locale.getString("error.516"), Locale.getString("gui_history"));
        CommandManager.execute(VendorCommandsEnum.GAME_PAUSED, false);
        ViewManager.getLayer(DefaultLayers.SplashOverlay).completeClear();
    });
}

export function ShowHistoryPage(data) {
    HTMLPopupsManager.showPopup("history", data);
}

export function HideHistoryPage(data) {
    HTMLPopupsManager.closePopup("history");
    CommandManager.execute(VendorCommandsEnum.GAME_PAUSED, false);
}

export function ToggleGamePauseCommand(pause: boolean) {
    if(App.instance.paused != pause) {
        App.instance.paused = pause;
    }
}

export function SpinCommand(playSpinSound: boolean) {
    VendorModel.spinStartTime = Date.now();
    let skippable = new Array<string>(
      DefaultStates.Idle,
      DefaultStates.Finish,
      DefaultStates.ShowWin);

    if (stateMachine.currentState.name == DefaultStates.ShowWin) {
      const elapsedSeconds = (new Date().getTime() - (<any>stateMachine.currentState).timer) / 1000;
      if (elapsedSeconds < (App.config.autoSpinDelay || 0.1)) {
        // Ensure the player will see the win at least for a small amount of time.
        // Without this check if the player holds the spacebar, s/he will miss the winnings.
        return;
      }
    }

    if (!skippable.includes(stateMachine.currentState.name)) {
      // Fixes the nbt game hangs, when clicking fast
      // on the spin button, during big win
      return;
    }

    if (playSpinSound == true) {
      SoundController.playSound(SoundVars.BUTTON_SPIN, false);
    }

    stateMachine.skip();
  }

export function StartAutoplayCommand() {
    Tween.delayedCall(0.05, () => {
        UIController.setMode(UIModes.AUTO);
        AutoplayModel.startAutoSpin();
        GameCommands.SpinCommand(false);
        CommandManager.execute(VendorCommandsEnum.AUTOPLAY_STARTED);
    })
}
